//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */
import moment from "moment-timezone";

import universalImageActionsNotesNoteTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-notes-note.html';

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsNotesNote', ['$sce', function($sce) {
    return {
      restrict: 'E',
      scope: {
        note: '=',
      },
      template: universalImageActionsNotesNoteTemplate,
      link(scope, element) {
        const noteTextElement = element.find('.universal-note-text')[0];

        scope.model = {
          showFullNote: false,
          noteText: $sce.trustAsHtml(scope.note.text),
        };

        scope.model.toggleShowMore = function() {
          scope.model.showFullNote = !scope.model.showFullNote;
        };

        scope.model.shouldShowButton = function() {
          return scope.model.showFullNote || (noteTextElement && noteTextElement.offsetHeight < noteTextElement.scrollHeight);
        };

        function init() {
          if (scope.note && scope.note.timestamp) {
            scope.model.timeAgo = moment(scope.note.timestamp).fromNow();
          }
        }

        init();
      },
    };
  }]);
})();
